<template>
	<div class="d-flex justify-content-center align-items-center vh-100">
		<span
			class="spinner-border f-c-blue"
			role="status"
			aria-hidden="true"></span>
	</div>
</template>

<script>
export default {
	name: "SOLoadingPage",
}
</script>